<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="rounded-xl">
          <v-toolbar flat color="white">
            <v-toolbar-title class="title-displays">Envelopes de Assinaturas</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn @click="openEnvelopeDialog" text color="primary">
              Novo Envelope
              <v-icon>add</v-icon>
            </v-btn>
          </v-toolbar>

          <v-col cols="12">
            <v-text-field class="search-field px-4" prepend-icon="search" label="Buscar"
                          v-model="searchText" hint="Buscar por nome do Envelope" persistent-hint />
          </v-col>

          <v-data-table :loading="isLoadingEnvelopes" no-data-text="Sem Envelopes para exibir" :headers="headers"
                        :items="searchedEnvelopes">

            <template v-slot:item.attributes.status="{ item }">
              <span>{{ mapperStatus[item.attributes.status] }}</span>
            </template>

            <template v-slot:item.attributes.created="{ item }">
              <span>{{ formattedDate(item.attributes.created) }}</span>
            </template>

            <template v-slot:item.attributes.modified="{ item }">
              <span>{{ formattedDate(item.attributes.modified) }}</span>
            </template>

            <template v-slot:item.attributes.deadline_at="{ item }">
              <span>{{ formattedDate(item.attributes.deadline_at) }}</span>
            </template>

            <template v-slot:item.actions="{ item }">
              <span style="display: flex; justify-content: center; align-items: center; gap: 4px; width: 100%;">
                <v-icon small color="primary" class="mr-2" @click="openEnvelope(item)">
                  mdi-eye
                </v-icon>
                <v-icon small color="error" @click="confirmDeleteEnvelope(item.id)">
                  mdi-delete
                </v-icon>
              </span>
            </template>
          </v-data-table>
          <v-dialog v-model="loadingEnvelopeDialog" max-width="320" persistent>
            <v-list class="py-5" color="primary" elevation="12" rounded>
              <v-list-item class="d-flex justify-space-between">
                <div>
                  <span class="loading-text">Carregando Envelope</span>
                </div>
                <div>
                  <v-progress-circular color="#1A237E" indeterminate size="32" width="2"></v-progress-circular>
                </div>
              </v-list-item>
            </v-list>
          </v-dialog>
        </v-card>
      </v-col>

      <v-col>
        <NewEnvelopeModal
            v-if="envelopeDialog"
            :openModal="envelopeDialog"
            :closeFunc="closeEnvelopeDialog"
        />
      </v-col>

    </v-row>
  </v-container>
</template>

<script>
import SignaturesScript from './SignaturesScript';

export default SignaturesScript;
</script>

<style scoped>
.search-field {
  padding: 1em;
}

.loading-text {
  color: white;
  font-size: large;
}
</style>